import 'quill-emoji/dist/quill-emoji.js';
import { IMessage } from '../../../interfaces/graph-types';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ElementRef,
} from '@angular/core';
import { Subscription, BehaviorSubject } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import Quill from 'quill';

const Parchment = Quill.import('parchment');
let Block = Parchment.query('block');
// Block.tagName = 'DIV';
Quill.register(Block, true);

// Quill.register(Quill.import('attributors/style/background'), true);
// Quill.register(Quill.import('attributors/style/color'), true);
// Quill.register(Quill.import('attributors/style/size'), true);
// Quill.register(Quill.import('attributors/style/direction'), true);
// Quill.register(Quill.import('attributors/style/align'), true);

@Component({
  selector: 'text-editor',
  template: require('./text-editor.component.pug'),
  styles: [require('./text-editor.component.css').toString()],
})
export class TextEditorComponent implements OnInit {
  @Input('content')
  editorContent: string = null;

  private body_html: string = null;
  private body_text: string = null;
  private editor = null;
  private firstUpdate = false;
  modules = {};

  message: IMessage;

  @Input()
  styles: string = null;

  @Input()
  inputHtml: BehaviorSubject<string> = null;

  @Input()
  placeholder: string = null;

  @Input()
  minimal: boolean = false;

  @Output()
  onContentChanged = new EventEmitter();

  @Output()
  onEditorCreated = new EventEmitter();

  sub: Subscription = null;

  // -------------------------------------------------------------------
  constructor(private modalService: BsModalService, private elem: ElementRef) {
    if (!this.editorContent) this.editorContent = '';

    this.modules = {
      'emoji-textarea': true,
      'emoji-shortname': true,
      toolbar: {
        container: [
          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }],
          [{ indent: '-1' }, { indent: '+1' }],
          [{ align: [] }, { direction: 'rtl' }],
          [
            'video',
            'link',
            'image',
            'imageurl',
            // { placeholder: ['GuestName', 'HotelName'] },
          ],
          ['clean'],
        ], //defaultModules.toolbar,
        placeholder: 'Write your amazing email here...',
        handlers: {
          imageurl: this.imageHandler,
        },
      },
    };
  }

  // -------------------------------------------------------------------
  ngAfterViewInit() {
    setTimeout(() => {
      let btn = this.elem.nativeElement.querySelector('.ql-imageurl');
      btn.innerHTML = 'img';
    }, 0);
  }

  // -------------------------------------------------------------------
  ngOnInit() {}

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }

  // -------------------------------------------------------------------
  imageHandler(this: any) {
    const tooltip = this.quill.theme.tooltip;
    const originalSave = tooltip.save;
    tooltip.save = function (this: any) {
      const range = this.quill.getSelection(true);
      const value = this.textbox.value;
      if (value) {
        this.quill.insertEmbed(range.index, 'image', value, 'user');
      }
      tooltip.save = originalSave;
    };
    tooltip.edit('image');
  }

  // -------------------------------------------------------------------
  setContent(newValue) {
    this.editorContent = newValue;
    this.firstUpdate = true;
    // delay it to next loop as the value set is not set yet and so the old data is in the history
    setTimeout(() => {
      this.editor.history.clear();
    }, 0);
  }

  // -------------------------------------------------------------------
  onContentEditorChanged({
    editor,
    html,
    text,
    content,
    delta,
    oldDelta,
    source,
  }) {
    // console.warn('onContentEditorChanged: ' + text);
    if (this.onContentChanged) {
      this.onContentChanged.emit({
        html: html,
        text: text,
        firstUpdate: this.firstUpdate,
      });
    }

    this.firstUpdate = false;
    this.body_html = html;
    this.body_text = text;
  }

  // -------------------------------------------------------------------
  onEditorCreatedCallback(quill) {
    this.editor = quill;
    //console.log(quill);

    // change the link placeholder to www.github.com
    let tooltip = quill.theme.tooltip;
    let input = tooltip.root.querySelector('input[data-link]');
    input.dataset.link = 'https://google.com';

    if (this.onEditorCreated) this.onEditorCreated.emit(quill);

    this.sub = this.inputHtml.subscribe(newValue => {
      this.setContent(newValue);
    });
  }

  // // -------------------------------------------------------------------
  // sendEmail(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
  //   this.replyService.replyToEmail(
  //     this.reply.id,
  //     this.body_html,
  //     this.body_text,
  //     data => {
  //       //this.cancel.emit(true);
  //       //this.reply.hide = true;
  //       //this.selectedReply = null;
  //       onsuccess();
  //     },
  //     error => {
  //       onfailure(error);
  //     },
  //   );
  // }
}
